module.exports = __webpack_public_path__ + "img/back_neck_depth.e7ab7496.png";